import { enUS } from './en-US'
import { zhCN } from './zh-CN'
import { XMAX_SDK_DEFAULT_LOCALE } from '../build-config'

export type SDKLocale = 'en-US' | 'zh-CN'

export { XMAX_SDK_DEFAULT_LOCALE } from '../build-config'
export { API_ERROR_MESSAGES, resolveApiErrorMessage } from './api-error-codes'

export type SDKMessages = Record<string, string>

export type SDKI18n = {
  locale: SDKLocale
  t: (key: string, params?: Record<string, string | number | boolean | null | undefined>) => string
}

function formatTemplate(
  template: string,
  params?: Record<string, string | number | boolean | null | undefined>,
): string {
  if (!params) return template
  return template.replace(/\{(\w+)\}/g, (_, rawKey: string) => {
    const value = params[rawKey]
    return value === null || value === undefined ? '' : String(value)
  })
}

export function getDefaultMessages(locale: SDKLocale): SDKMessages {
  return locale === 'zh-CN' ? (zhCN as SDKMessages) : (enUS as SDKMessages)
}

export function createSDKI18n(input?: {
  locale?: SDKLocale
  messages?: Record<string, string>
  t?: SDKI18n['t']
}): SDKI18n {
  // The domestic package defaults to Chinese and the global package defaults
  // to English. An explicitly supplied locale/i18n still takes precedence.
  const locale = input?.locale ?? XMAX_SDK_DEFAULT_LOCALE

  if (typeof input?.t === 'function') {
    return { locale, t: input.t }
  }

  const base = getDefaultMessages(locale)
  const merged: SDKMessages = { ...base, ...(input?.messages ?? {}) }

  return {
    locale,
    t: (key, params) => {
      const template = merged[key] ?? key
      return formatTemplate(template, params)
    },
  }
}
